import styled from 'styled-components';

const ContainerSectionOneImage = styled.div`
  background-image: url(${`${process.env.PUBLIC_URL}fayvenDashImage.png`});
  width: 100%;
  height: 750px;
  margin-top: 80px;
  background-repeat: no-repeat;
  background-size: contain;
  background-size: cover;
  background-position: center;
`;
export { ContainerSectionOneImage };
